import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDocModuleIcon } from './docModuleIcons';

const DocModuleIcon = ({ moduleId, variant = 'sidebar', accent }) => {
  const icon = getDocModuleIcon(moduleId);
  const style = accent ? { '--doc-accent': accent } : undefined;

  return (
    <span className={`doc-fa-icon doc-fa-icon--${variant}`} style={style} aria-hidden="true">
      <FontAwesomeIcon icon={icon} />
    </span>
  );
};

export default DocModuleIcon;
